import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
    },
    container: {
        border: `1px solid ${theme.palette.emteria.border.primary}`,
        borderRadius: theme.spacing(1),
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        backgroundColor: theme.palette.emteria.background.paper,
        padding: theme.spacing(1),
    },
    emptyContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    virtualListInner: {
        width: "100%",
        position: "relative",
        minHeight: "100%",
    },
    virtualRow: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
    },
    searchField: {
        marginBottom: theme.spacing(1),
        flexShrink: 0,
    },
    matchInfo: {
        display: "block",
        marginBottom: theme.spacing(1),
        color: theme.palette.text.secondary,
        flexShrink: 0,
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: theme.spacing(1),
        gap: theme.spacing(1),
        flexShrink: 0,
    },
    selectAllBox: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        padding: theme.spacing(0.5, 1),
        borderRadius: theme.spacing(0.5),
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
    },
    emptyState: {
        padding: theme.spacing(2),
        textAlign: "center" as const,
    },
}));
